import { Fragment } from "react";
import { FormTransferItemsType } from "../types";
import { AttachmentSection } from "../../components";
import { useFormContext } from "react-hook-form";

export function AttachmentModal(): JSX.Element {
    const { control, getValues, setValue, watch } = useFormContext<FormTransferItemsType>()
    const trx_code = watch('trx_code')

    return (
        <Fragment>
            <AttachmentSection<FormTransferItemsType>
                addApi="/transfer/uploadfile"
                removeApi="/transfer/removefile?strPath"
                trx_code={trx_code!}
                control={control}
                setValue={setValue}
                getValues={getValues}
                name="imgPath"
            />
        </Fragment>
    )
}
